<template>
  <div class="config-container">
    <div class="row flex-container" v-bind:class="[ readonly === true ? 'readOnly' : 'normalMode' ]">

      <h2 class="card-category col-12" v-if="alerts.sos">{{ $t('profile.alerts.heading') }}</h2>

      <CardAlert
          v-for="(tag,key) in alerts"
          :alertKey="key"
          :alerts="tag.alert"
          :class="{disabled:!hasUserValidOffer(tag),'licence-offer-difference':!hasUserValidOffer(tag)}"
          :key='key'
          :readonly="readonly"
          @change="modification('config')"
      >

                <span slot="title">
                    {{ tag.description }}
                    <UiInfoTooltip
                        v-if="$te(`profile.helpers.${key}`)"
                        :content="$t(`profile.helpers.${key}`)"
                    />
                </span>

        <i :class="icons[key]" slot="icon"></i>

        <template v-for="(tagChild,keyChild) in tag">

          <!-- Switcher button to propose the sos button -->
          <div :class="{'licence-offer-difference':!hasUserValidOffer(tagChild)}"
               :title="getTooltipForCard(tagChild,key,keyChild)"
               class="button-switch"
               v-if="tagChild.type == 'boolean'"
               v-show="!isUnusedItem(tagChild)"
          >
            <b-form-checkbox class="switcher"
                             v-model="tagChild.value"
                             :checked="tagChild.value == 1 ? true : false"
                             @change="modification('config')"
                             :disabled="!hasUserValidOffer(tagChild)"
                             value="1"
                             unchecked-value="0"
                             switch>
                            <span class="d-flex align-items-center">
                                {{ tagChild.description }}
                                <UiInfoTooltip
                                    v-if="$te(`profile.helpers.${key}-${keyChild}`)"
                                    :content="$t(`profile.helpers.${key}-${keyChild}`)"
                                />
                            </span>
            </b-form-checkbox>
          </div>

          <!-- List -->
          <div :class="{'licence-offer-difference':!hasUserValidOffer(tagChild)}"
               :title="getTooltipForCard(tagChild,key,keyChild)" class="form-row"
               v-if="tagChild.type == 'list'"
               v-show="!isUnusedItem(tagChild)"
          >
            <div class="d-flex align-items-center">
              <label>{{ tagChild.description }}</label>
              <UiInfoTooltip
                  v-if="$te(`profile.helpers.${key}-${keyChild}`)"
                  :content="$t(`profile.helpers.${key}-${keyChild}`)"
              />
            </div>
            <select :disabled="!hasUserValidOffer(tagChild)" @change="modification('config')"
                    class="form-input col"
                    v-model="tagChild.value">
              <option :value="keyVal" v-for="(val,keyVal) in tagChild.values">
                {{ val }}
              </option>
            </select>
          </div>

          <!-- Range selecter to select the press time -->
          <div :class="{'licence-offer-difference':!hasUserValidOffer(tagChild)}"
               :title="getTooltipForCard(tagChild,key,keyChild)"
               class="with-complex-range press-time-select"
               v-if="tagChild.type == 'number'"
               v-show="!isUnusedItem(tagChild)"
          >
            <div class="d-flex align-items-center">

              <label class="tagchild-description">{{ tagChild.description }}</label>
              <UiInfoTooltip
                  v-if="$te(`profile.helpers.${key}-${keyChild}`)"
                  :content="$t(`profile.helpers.${key}-${keyChild}`)"
              />
            </div>

            <div class="d-flex align-items-center gap-3">
              <!-- Press time value -->
              <div class="d-flex align-items-center gap-1">
                            <input :readonly="readonly" @blur="handleBlurNumberField(tagChild, tagChild.values.min, tagChild.values.max, tagChild.values.step)" @change="modification('config')"
                       class="value value-input-time-press"
                       type="text"
                       :disabled="!hasUserValidOffer(tagChild)"
                       v-model="tagChild.value"/>
                <span class="unit">
                                    {{ tagChild.unit }}
                            </span>
                <span class="converted"
                      v-if="(tagChild.unit == 'm' && tagChild.value >= 60)">
                                    ({{ convertInHour(tagChild.value) }})
                            </span>
                <span class="converted"
                      v-if="tagChild.unit == 's' && tagChild.value >= 60">
                                    ({{ convertInMin(tagChild.value) }})
                            </span>
              </div>
              <!-- Input press time selector-->
              <input :disabled="!hasUserValidOffer(tagChild)" :max="tagChild.values.max" :min="tagChild.values.min"
                     :step="tagChild.values.step"
                            @change="modification('config')" class="form-input" :class="{'over-threshold': tagChild.values.threshold && ((tagChild.value > tagChild.values.threshold.max.value) || (tagChild.value < tagChild.values.threshold.min.value))}"
                     type="range"
                     v-model="tagChild.value"
              />

            </div>
                    <div class="over-threshold-text" v-if="tagChild.values.threshold && ((tagChild.value > tagChild.values.threshold.max.value) || (tagChild.value < tagChild.values.threshold.min.value))">
              <template v-if="tagChild.value > tagChild.values.threshold.max.value">
                {{ tagChild.values.threshold.max.text }}
              </template>
              <template v-if="tagChild.value < tagChild.values.threshold.min.value">
                {{ tagChild.values.threshold.min.text }}
              </template>
            </div>
                    <div class="fall-sensitivity-level" v-if="tagChild.values.sensitivity_level">{{ getFallSensitivityLevel(tagChild.value, tagChild.values.sensitivity_level)}} </div>
          </div>
        </template>

        <div
            v-if="$te(`profile.helpers.${key}-footer`)"
            v-html="$t(`profile.helpers.${key}-footer`)"
            class="mt-3 text-gray-500"
        ></div>

      </CardAlert>

    </div>

    <div class="row flex-container">
      <h2 class="card-category">{{ $t('profile.sound_effect.heading') }}</h2>
      <CardAlertSoundEffect v-if="soundAlertEffectConfig && Object.keys(soundEffectConfig).length !== 0"
                       :sounds="soundAlertEffectConfig" :readonly="readonly" @change="modification('config')"/>

      <CardSoundEffect v-if="soundEffectConfig && Object.keys(soundEffectConfig).length !== 0"
                       :sounds="soundEffectConfig" :readonly="readonly" @change="modification('config')"/>
    </div>

    <div class="row flex-container">
      <!-- Second part -->
      <template v-for="(categoryItems, categoryKey) in configCategories">
        <h2 :key="categoryKey" class="card-category" v-if="categoryItems.length > 0">
          {{ $t(categoriesLabel[categoryKey]) }}
        </h2>
        <CardSimple
            v-for="(categoryItem,index) in categoryItems"
            :class="{'licence-offer-difference':!hasUserValidOffer(categoryItem),disabled:!hasUserValidOffer(categoryItem)}"
            :key='`${categoryKey}-${index}`'
            :title="getTooltipForCard(categoryItem,categoryItem.key)"
            v-show="!isUnusedItem(categoryItem)"
        >

          <IconWatchmanVisibility v-if="categoryItem.key === 'level_visibility'" slot="icon"/>
          <i v-else :class="icons[categoryItem.key]" slot="icon"></i>

          <span slot="title">
                      {{ categoryItem.description }}
                    </span>

          <UiSwitch
              v-if="categoryItem.type == 'boolean'"
              v-model="categoryItem.value"
              :true-value="1"
              :false-value="0"
          />

          <div class="form-row with-complex-range" v-if="categoryItem.type == 'number'">
                        <span class="value">
                            <input :readonly="readonly"
                                   @blur="handleBlurNumberField(categoryItem, categoryItem.values.min, categoryItem.values.max, categoryItem.values.step)"
                                   @change="modification('config')"
                                   class="value"
                                   type="text"
                                   v-model="categoryItem.value"/>
                            <span
                                class="unit">{{ categoryItem.unit }}
                            </span><br>
                            <span class="value-conversion"
                                  v-if="(categoryItem.unit == 's' && categoryItem.value >= 60)">
                              ({{ convertInMin(categoryItem.value) }})
                            </span>
                            <span class="value-conversion"
                                  v-if="(categoryItem.unit == 'm' && categoryItem.value >= 60)">
                                ({{ convertInHour(categoryItem.value) }})
                            </span>
                        </span>
            <input :disabled="readonly" :max="categoryItem.values.max" :min="categoryItem.values.min"
                   :step="categoryItem.values.step"
                   @change="modification('config')" class="form-input"
                   :class="{'over-threshold': categoryItem.values.threshold && ((categoryItem.value > categoryItem.values.threshold.max.value) || (categoryItem.value < categoryItem.values.threshold.min.value))}"
                   type="range"
                   v-model="categoryItem.value"/>
                        <div class="over-threshold-text" v-if="categoryItem.values.threshold && ((categoryItem.value > categoryItem.values.threshold.max.value) || (categoryItem.value < categoryItem.values.threshold.min.value))">
              <template v-if="categoryItem.value > categoryItem.values.threshold.max.value">
                {{ categoryItem.values.threshold.max.text }}
              </template>
              <template v-if="categoryItem.value < categoryItem.values.threshold.min.value">
                {{ categoryItem.values.threshold.min.text }}
              </template>
            </div>
          </div>
          <div class="form-row" v-if="categoryItem.type == 'list'">
            <select :disabled="readonly" @change="modification('config')"
                    class="form-input col"
                    v-model="categoryItem.value">
              <option :value="keyVal" :key="keyVal" v-for="(val,keyVal) in categoryItem.values">{{ val }}
              </option>
            </select>
          </div>
          <div class="form-row" v-if="categoryItem.type == 'relation'">
            <select :disabled="readonly" @change="modification('config', categoryItem.key)"
                    class="form-input col"
                    v-model="categoryItem.value">
              <option></option>
                            <option :value="val.id" :key="keyVal" v-for="(val,keyVal) in categoryItem.values">{{ constructLabelByKey(categoryItem.key,val)}}
              </option>
            </select>
          </div>
          <div class="more-infos-inner" slot="moreInfos">
            <div class="license">
              <span class="licence-type-45" v-if="categoryItem.offers.includes('45')" v-html="pictoStandard"></span>
              <span class="licence-type-43" v-else-if="categoryItem.offers.includes('43')" v-html="pictoPremium"></span>
              <span class="licence-type-35" v-else-if="categoryItem.offers.includes('35')" v-html="pictoPremium"></span>
                            <span class="licence-type-58" v-else-if="categoryItem.offers.includes('58')" v-html="pictoEnterprise"></span>
              <span class="licence-type-57" v-else-if="categoryItem.offers.includes('57')">
                              <i class="fa fa-upload"></i>
                            </span>
            </div>
            <div class="os">
              <i :class="{disabled:categoryItem.compatible_android == 0}" class="fa fa-android"></i>
              <i :class="{disabled:categoryItem.compatible_ios == 0}" class="fa fa-apple"></i>
            </div>
          </div>
        </CardSimple>
      </template>
    </div>
  </div>
</template>

<script>
import Utils from "@/services/utils.js";
import Auth from "@/services/auth.js";
import CardSimple from "@/components/ui/cards/CardSimple";
import CardAlert from "@/components/ui/cards/CardAlert";
import CardAlertSoundEffect from "@/components/ui/cards/CardAlertSoundEffect";
import CardSoundEffect from "@/components/ui/cards/CardSoundEffect";
import moment from 'moment'
import Icons from "@/services/iconMapping.js";
import pickBy from 'lodash/pickBy';
import BadgeNew from "@/components/ui/BadgeNew";
import UiSwitch from "@/components/ui/Switch";
import UiInfoTooltip from "@/components/ui/InfoTooltip.vue";
import {IconWatchmanVisibility} from '@/components/icons'

import picto_standard from '@/assets/img/picto/1_Standard_yellow.svg'
import picto_premium from '@/assets/img/picto/2_Premium_yellow.svg'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_yellow.svg'

export default {
  name: 'config',
  components: {
    BadgeNew,
    UiInfoTooltip,
    UiSwitch,
    CardSimple,
    CardAlert,
    CardAlertSoundEffect,
    CardSoundEffect,
    IconWatchmanVisibility,
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    filterStr: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    version: {
      type: String,
      default: null
    },
    datiOffer: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      checked: true,
      categoriesItemMapping: {
        mode: 0,
        auto_offhook: 0,
        dedicated_device: 0,
        allow_monitoring_inhibition: 1,
        gps: 1,
        bt: 2,
        nfc: 2,
        battery: 3,
        telesurveilleur: 3,
        phone: 3,
        phonebook_id: 3,
        idcard: 3,
        video: 3,
        ppe_list_id: 3,
        desk_mode: 3,
        road_mode: 3,
        level_visibility: 3
      },
      categoriesLabel: {
        0: "profile.items.headings.device",
        1: "profile.items.headings.security",
        2: "profile.items.headings.location",
        3: "profile.items.headings.other",
      }
    }
  },
  computed: {
    pictoStandard() {
      return picto_standard
    },
    pictoPremium() {
      return picto_premium
    },
    pictoEnterprise() {
      return picto_enterprise
    },
    isClientSDF() {
      return window.V.clientInfos.code === "SDF0001"
    },
    alerts: function () {
      var vThis = this;
      var newArray = pickBy(this.config, function (obj, key) {
        if (obj.server_only == 1) {
          return false;
        }
        if (vThis.filterStr == '') {
          return obj.alert != null || obj?.key === 'lostcom';
        } else {
          var isAlert = obj.alert != null || obj?.key === 'lostcom';
          var filterOk = Utils.sanitize(obj.description).indexOf(vThis.filterStr) != -1;
          var filterChildrenOK = false;
          for (var child in obj) {
            if (obj[child] != null && obj[child].description != null && Utils.sanitize(obj[child].description).indexOf(vThis.filterStr) != -1) {
              filterChildrenOK = true;
            }
          }
          return isAlert && (filterOk || filterChildrenOK);
        }
      });
      return newArray;
    },
    configCategories: function () {
      const categories = {
        0: [],
        1: [],
        2: [],
        3: [],
      };

      Object.keys(this.config).forEach(key => {
        if (Object.keys(this.categoriesItemMapping).includes(key)) {
          if (this.filterStr == '' || Utils.sanitize(this.config[key].description).indexOf(this.filterStr) != -1) {
            categories[this.categoriesItemMapping[key]].push(this.config[key]);
          }
        }
      })

      return categories;
    },
    soundAlertEffectConfig: function () {
      return this.config.prealert || null;
    },
    soundEffectConfig: function () {
      return this.config.sound_effect || null;
    },
    icons: function () {
      return Icons.profile;
    },
  },
  methods: {
    getFallSensitivityLevel(sensitiviy, reference) {
      if (sensitiviy && reference) {
        return reference[sensitiviy]
        }
        else {
        return null
      }
    },
    hasUserValidOffer: function (item) {

      if (item.feature_flag == undefined) return true;
      return (item.feature_flag.access);
    },
    isUnusedItem: function (item) {
      if (item.offers) {
        if (item.offers[0] == '') {
          return true
        }
      } else {
        return false
      }
    },
    hasLicenceValidOffer: function (item) {
      if (item.feature_flag == undefined) return true;
      return (item.feature_flag.access);
    },
    constructLabelByKey: function (key, obj) {
      if (key == 'telesurveilleur') {
        if (obj.country != null) {
          return obj.country.name + ' - ' + obj.name;
        }
      }
      return obj.name;

    },
    getMin: function (values) {
      let temp = values.split(';');
      return temp[0];
    },
    getMax: function (values) {
      let temp = values.split(';');
      return temp[1];
    },
    getStep: function (values) {
      let temp = values.split(';');
      return temp[2];
    },
    oddOrEven: function (tags, even) {
      if (even == null) {
        even = 0;
      }
      let i = 0;
      let newArray = pickBy(tags, function (obj, key) {
        let cond = i % 2 === parseInt(even);
        i++;
        return cond;
      });
      return newArray;
    },
    byColumn: function (tags, totalColumns, columnNumber) {
      let i = 0;
      let newArray = pickBy(tags, function (obj, key) {
        let cond = i % totalColumns === (columnNumber - 1);
        i++;
        return cond;
      });
      return newArray;
    },
    byColumnAndRow: function (tags, totalColumns, columnNumber, rowNumber) {
      let i = 0;
      let newArray = pickBy(tags, function (obj, key) {
        let cond = i % totalColumns === (columnNumber - 1);
        if (i % totalColumns == 0) {
          if ((i) != (totalColumns * (rowNumber - 1))) {
            cond = false;
          }
        } else {
          if ((i - 1) != (totalColumns * (rowNumber - 1))) {
            cond = false;
          }
        }
        i++;
        return cond;
      });
      return newArray;
    },
    convertInMin: function (val) {
      let m = moment.duration(parseInt(val), 'seconds');
      let min = m.minutes();
      let sec = m.seconds();
      let ret = min + 'm';
      if (sec != 0) {
        ret += ' ' + sec + 's';
      }
      return ret;
    },
    convertInHour: function (val) {
      let h = moment.duration(parseInt(val), 'minutes');
      let hour = h.hours();
      let min = h.minutes();
      let ret = hour + 'h';
      if (min != 0) {
        ret += ' ' + min + 'm';
      }
      return ret;
    },
    handleBlurNumberField: function (tag, min, max, step) {
      if (tag.value < min) {
        tag.value = min;
      }
      if (tag.value > max) {
        tag.value = max;
      }
      if (tag.value % step != 0) {
        tag.value = Math.floor(tag.value);
      }
    },
    modification: function (section, key) {
      this.$emit('change', section, key);
    },
    getTooltipForCard: function (item, key, key2) {
      let tooltip = '';
      let tradKey = key;
      if (key2 != null) {
        tradKey += '.' + key2;
      }
      if (Utils.te('profile.items.' + tradKey)) {
        tooltip = Utils.t('profile.items.' + tradKey);
      }
      if (!this.hasLicenceValidOffer(item)) {
        tooltip += '\n' + Utils.t('profile.tooltipsProfileItem.noValidOffer');
      }
      return tooltip;
    }
  }
}
</script>

<style lang="scss" scoped>

.config-container {

  &:last-child {
    margin-bottom: 0px;
  }

  .card {
    margin-bottom: 40px;
  }

  .flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;

    &:after {
      content: "";
      width: calc(33.33% - 20px);
    }

    .card {
      display: inline-block;
      flex: 0 0 auto;
      width: calc(33.33% - 15px);
      padding: 0;
      margin-left: 10px;

      &.card-alert {
        width: calc(50% - 10px);
      }
    }
  }

  .no-profile {
    color: #212121;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    opacity: 0.9;
    text-align: center;
    width: 100%;

    .fa {
      color: red;
      flex-wrap: wrap;
      font-size: 7rem;
    }

    h2 {
      font-size: 1.5rem;
      font-weight: 700;
      margin: 30px 0 10px;
    }
  }
}


.switcher {
  margin-bottom: 4px;
}

.alert-description {
  margin-top: 20px;
  margin-bottom: 14px;
}

.button-switch {
  margin-bottom: 15px;
}
.press-time-select {
  margin-bottom: 15px;
}

.form-row {
  display: block;
}

#profile-form .config-col > .config-container > .row, #device-form .config-col > .config-container > .row {
  max-width: 80%;
}

.value-input-time-press {
  padding-left: 8px !important;
  font-size: 14px;
  width: 3rem;
  height: 24px;
  border: var(--input-border);
  border-radius: var(--input-radius);
}

.unit {
  font-size: 13px;
  margin-left: 4px;
  vertical-align: bottom;
  height: 18px;
}

.converted {
  font-size: 13px;
  margin-left: 4px;
  vertical-align: bottom;
  height: 20px;
}

</style>


<style lang="scss">

.normalMode {
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #ffe19b !important;
    background-color: #ffc107 !important;
  }

  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: grey !important;
  }

  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none !important;
  }
}

.readOnly {
  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #FFE9B9FF !important;
    background-color: #FFE9B9FF !important;
  }

  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: grey !important;
  }

  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none !important;
  }
}
</style>

